import React, { Component } from 'react'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false
    }
  }
  changeVisible = () => {
    this.setState({
      visible: !this.state.visible
    })
  }
  render() {
    let { title, children } = this.props
    return (
      <div className={styles.questionList}>
        <p className={styles.title} onClick={this.changeVisible}>
          Q：{title}
          {this.state.visible ? (
            <UpOutlined className={styles.arrow} />
          ) : (
            <DownOutlined className={styles.arrow} />
          )}
        </p>
        {this.state.visible && <div className={styles.content}>{children}</div>}
      </div>
    )
  }
}
